var me = Object.defineProperty;
var W = (a) => {
  throw TypeError(a);
};
var ke = (a, c, e) => c in a ? me(a, c, { enumerable: !0, configurable: !0, writable: !0, value: e }) : a[c] = e;
var b = (a, c, e) => ke(a, typeof c != "symbol" ? c + "" : c, e), j = (a, c, e) => c.has(a) || W("Cannot " + e);
var s = (a, c, e) => (j(a, c, "read from private field"), e ? e.call(a) : c.get(a)), d = (a, c, e) => c.has(a) ? W("Cannot add the same private member more than once") : c instanceof WeakSet ? c.add(a) : c.set(a, e), f = (a, c, e, t) => (j(a, c, "write to private field"), t ? t.call(a, e) : c.set(a, e), e), h = (a, c, e) => (j(a, c, "access private method"), e);
import { E as ve, d as we, x as Y, T as g, R as Te, p as Pe, y as x, c as A, a as Ce, z as G, L as M, l as $e, B as ge, C as Ee, I as Re, Q as J } from "./vidstack-8s6P_CC9.js";
const Ve = /(?:https:\/\/)?(?:player\.)?vimeo(?:\.com)?\/(?:video\/)?(\d+)(?:(?:\?hash=|\?h=|\/)(.*))?/, O = /* @__PURE__ */ new Map(), _ = /* @__PURE__ */ new Map();
function K(a) {
  const c = a.match(Ve);
  return { videoId: c == null ? void 0 : c[1], hash: c == null ? void 0 : c[2] };
}
async function X(a, c, e) {
  if (O.has(a)) return O.get(a);
  if (_.has(a)) return _.get(a);
  let t = `https://vimeo.com/api/oembed.json?url=https://player.vimeo.com/video/${a}`;
  e && (t = t.concat(`?h=${e}`));
  const n = window.fetch(t, {
    mode: "cors",
    signal: c.signal
  }).then((r) => r.json()).then((r) => {
    var N, U;
    const l = /vimeocdn.com\/video\/(.*)?_/, p = (U = (N = r == null ? void 0 : r.thumbnail_url) == null ? void 0 : N.match(l)) == null ? void 0 : U[1], C = p ? `https://i.vimeocdn.com/video/${p}_1920x1080.webp` : "", $ = {
      title: (r == null ? void 0 : r.title) ?? "",
      duration: (r == null ? void 0 : r.duration) ?? 0,
      poster: C,
      pro: !0
    };
    return O.set(a, $), $;
  }).finally(() => _.delete(a));
  return _.set(a, n), n;
}
const Ie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getVimeoVideoInfo: X,
  resolveVimeoVideoId: K
}, Symbol.toStringTag, { value: "Module" }));
var o, y, m, w, E, S, k, R, I, T, v, V, i, Z, H, ee, te, P, se, ie, ne, Q, oe, he, re, ae, ce, q, ue, le, fe, L, de, F, pe, B, ye, be, u, D, z;
class Se extends ve {
  constructor(e, t) {
    super(e);
    d(this, i);
    b(this, "$$PROVIDER_TYPE", "VIMEO");
    b(this, "scope", we());
    b(this, "fullscreen");
    d(this, o);
    d(this, y, Y(""));
    d(this, m, Y(!1));
    d(this, w, null);
    d(this, E, null);
    d(this, S, !1);
    d(this, k, new g(0, 0));
    d(this, R, new Te(h(this, i, te).bind(this)));
    d(this, I, null);
    d(this, T, null);
    d(this, v, /* @__PURE__ */ new Map());
    d(this, V, null);
    /**
     * Whether tracking session data should be enabled on the embed, including cookies and analytics.
     * This is turned off by default to be GDPR-compliant.
     *
     * @defaultValue `false`
     */
    b(this, "cookies", !1);
    b(this, "title", !0);
    b(this, "byline", !0);
    b(this, "portrait", !0);
    b(this, "color", "00ADEF");
    // Embed will sometimes dispatch 0 at end of playback.
    d(this, P, !1);
    f(this, o, t);
    const n = this;
    this.fullscreen = {
      get active() {
        return s(n, S);
      },
      supported: !0,
      enter: () => h(this, i, u).call(this, "requestFullscreen"),
      exit: () => h(this, i, u).call(this, "exitFullscreen")
    };
  }
  get type() {
    return "vimeo";
  }
  get currentSrc() {
    return s(this, E);
  }
  get videoId() {
    return s(this, y).call(this);
  }
  get hash() {
    return s(this, w);
  }
  get isPro() {
    return s(this, m).call(this);
  }
  preconnect() {
    Pe(this.getOrigin());
  }
  setup() {
    super.setup(), x(h(this, i, Z).bind(this)), x(h(this, i, H).bind(this)), x(h(this, i, ee).bind(this)), s(this, o).notify("provider-setup", this);
  }
  destroy() {
    h(this, i, D).call(this), this.fullscreen = void 0;
    const e = "provider destroyed";
    for (const t of s(this, v).values())
      for (const { reject: n } of t) n(e);
    s(this, v).clear(), h(this, i, u).call(this, "destroy");
  }
  async play() {
    return h(this, i, u).call(this, "play");
  }
  async pause() {
    return h(this, i, u).call(this, "pause");
  }
  setMuted(e) {
    h(this, i, u).call(this, "setMuted", e);
  }
  setCurrentTime(e) {
    h(this, i, u).call(this, "seekTo", e), s(this, o).notify("seeking", e);
  }
  setVolume(e) {
    h(this, i, u).call(this, "setVolume", e), h(this, i, u).call(this, "setMuted", A(s(this, o).$state.muted));
  }
  setPlaybackRate(e) {
    h(this, i, u).call(this, "setPlaybackRate", e);
  }
  async loadSource(e) {
    if (!Ce(e.src)) {
      f(this, E, null), f(this, w, null), s(this, y).set("");
      return;
    }
    const { videoId: t, hash: n } = K(e.src);
    s(this, y).set(t ?? ""), f(this, w, n ?? null), f(this, E, e);
  }
  getOrigin() {
    return "https://player.vimeo.com";
  }
  buildParams() {
    const { keyDisabled: e } = s(this, o).$props, { playsInline: t, nativeControls: n } = s(this, o).$state, r = n();
    return {
      title: this.title,
      byline: this.byline,
      color: this.color,
      portrait: this.portrait,
      controls: r,
      h: this.hash,
      keyboard: r && !e(),
      transparent: !0,
      playsinline: t(),
      dnt: !this.cookies
    };
  }
  onMessage(e, t) {
    e.event ? h(this, i, ye).call(this, e.event, e.data, t) : e.method && h(this, i, oe).call(this, e.method, e.value, t);
  }
  onLoad() {
  }
}
o = new WeakMap(), y = new WeakMap(), m = new WeakMap(), w = new WeakMap(), E = new WeakMap(), S = new WeakMap(), k = new WeakMap(), R = new WeakMap(), I = new WeakMap(), T = new WeakMap(), v = new WeakMap(), V = new WeakMap(), i = new WeakSet(), Z = function() {
  h(this, i, D).call(this);
  const e = s(this, y).call(this);
  if (!e) {
    this.src.set("");
    return;
  }
  this.src.set(`${this.getOrigin()}/video/${e}`), s(this, o).notify("load-start");
}, H = function() {
  const e = s(this, y).call(this);
  if (!e) return;
  const t = G(), n = new AbortController();
  return f(this, V, t), X(e, n, s(this, w)).then((r) => {
    t.resolve(r);
  }).catch((r) => {
    t.reject();
  }), () => {
    t.reject(), n.abort();
  };
}, ee = function() {
  const e = s(this, m).call(this), { $state: t, qualities: n } = s(this, o);
  if (t.canSetPlaybackRate.set(e), n[M.setReadonly](!e), e)
    return $e(n, "change", () => {
      var l;
      if (n.auto) return;
      const r = (l = n.selected) == null ? void 0 : l.id;
      r && h(this, i, u).call(this, "setQuality", r);
    });
}, te = function() {
  h(this, i, u).call(this, "getCurrentTime");
}, P = new WeakMap(), se = function(e, t) {
  if (s(this, P) && e === 0) return;
  const { realCurrentTime: n, paused: r, bufferedEnd: l, seekableEnd: p, live: C } = s(this, o).$state;
  if (n() === e) return;
  const $ = n();
  s(this, o).notify("time-change", e, t), Math.abs($ - e) > 1.5 && (s(this, o).notify("seeking", e, t), !r() && l() < e && s(this, o).notify("waiting", void 0, t)), !C() && p() - e < 0.01 && (s(this, o).notify("end", void 0, t), f(this, P, !0), setTimeout(() => {
    f(this, P, !1);
  }, 500));
}, ie = function(e, t) {
  s(this, o).notify("seeked", e, t);
}, ne = function(e) {
  var n;
  const t = s(this, y).call(this);
  (n = s(this, V)) == null || n.promise.then((r) => {
    if (!r) return;
    const { title: l, poster: p, duration: C, pro: $ } = r;
    s(this, m).set($), s(this, o).notify("title-change", l, e), s(this, o).notify("poster-change", p, e), s(this, o).notify("duration-change", C, e), h(this, i, Q).call(this, C, e);
  }).catch(() => {
    t === s(this, y).call(this) && (h(this, i, u).call(this, "getVideoTitle"), h(this, i, u).call(this, "getDuration"));
  });
}, Q = function(e, t) {
  const { nativeControls: n } = s(this, o).$state, r = n();
  f(this, k, new g(0, e));
  const l = {
    buffered: new g(0, 0),
    seekable: s(this, k),
    duration: e
  };
  s(this, o).delegate.ready(l, t), r || h(this, i, u).call(this, "_hideOverlay"), h(this, i, u).call(this, "getQualities"), h(this, i, u).call(this, "getChapters");
}, oe = function(e, t, n) {
  var r;
  switch (e) {
    case "getVideoTitle":
      const l = t;
      s(this, o).notify("title-change", l, n);
      break;
    case "getDuration":
      const p = t;
      s(this, o).$state.canPlay() ? s(this, o).notify("duration-change", p, n) : h(this, i, Q).call(this, p, n);
      break;
    case "getCurrentTime":
      h(this, i, se).call(this, t, n);
      break;
    case "getBuffered":
      ge(t) && t.length && h(this, i, q).call(this, t[t.length - 1][1], n);
      break;
    case "setMuted":
      h(this, i, L).call(this, A(s(this, o).$state.volume), t, n);
      break;
    // case 'getTextTracks':
    //   this.#onTextTracksChange(data as VimeoTextTrack[], trigger);
    //   break;
    case "getChapters":
      h(this, i, de).call(this, t);
      break;
    case "getQualities":
      h(this, i, pe).call(this, t, n);
      break;
  }
  (r = h(this, i, z).call(this, e)) == null || r.resolve();
}, he = function() {
  for (const e of Ee)
    h(this, i, u).call(this, "addEventListener", e);
}, re = function(e) {
  s(this, R).stop(), s(this, o).notify("pause", void 0, e);
}, ae = function(e) {
  s(this, R).start(), s(this, o).notify("play", void 0, e);
}, ce = function(e) {
  const { paused: t } = s(this, o).$state;
  !t() && !s(this, P) && s(this, o).notify("playing", void 0, e);
}, q = function(e, t) {
  const n = {
    buffered: new g(0, e),
    seekable: s(this, k)
  };
  s(this, o).notify("progress", n, t);
}, ue = function(e) {
  s(this, o).notify("waiting", void 0, e);
}, le = function(e) {
  const { paused: t } = s(this, o).$state;
  t() || s(this, o).notify("playing", void 0, e);
}, fe = function(e) {
  const { paused: t } = s(this, o).$state;
  t() && s(this, o).notify("play", void 0, e), s(this, o).notify("waiting", void 0, e);
}, L = function(e, t, n) {
  const r = { volume: e, muted: t };
  s(this, o).notify("volume-change", r, n);
}, // #onTextTrackChange(track: VimeoTextTrack, trigger: Event) {
//   const textTrack = this.#ctx.textTracks.toArray().find((t) => t.language === track.language);
//   if (textTrack) textTrack.mode = track.mode;
// }
// #onTextTracksChange(tracks: VimeoTextTrack[], trigger: Event) {
//   for (const init of tracks) {
//     const textTrack = new TextTrack({
//       ...init,
//       label: init.label.replace('auto-generated', 'auto'),
//     });
//     textTrack[TextTrackSymbol.readyState] = 2;
//     this.#ctx.textTracks.add(textTrack, trigger);
//     textTrack.setMode(init.mode, trigger);
//   }
// }
// #onCueChange(cue: VimeoTextCue, trigger: Event) {
//   const { textTracks, $state } = this.#ctx,
//     { currentTime } = $state,
//     track = textTracks.selected;
//   if (this.#currentCue) track?.removeCue(this.#currentCue, trigger);
//   this.#currentCue = new window.VTTCue(currentTime(), Number.MAX_SAFE_INTEGER, cue.text);
//   track?.addCue(this.#currentCue, trigger);
// }
de = function(e) {
  if (h(this, i, F).call(this), !e.length) return;
  const t = new Re({
    kind: "chapters",
    default: !0
  }), { seekableEnd: n } = s(this, o).$state;
  for (let r = 0; r < e.length; r++) {
    const l = e[r], p = e[r + 1];
    t.addCue(
      new window.VTTCue(
        l.startTime,
        (p == null ? void 0 : p.startTime) ?? n(),
        l.title
      )
    );
  }
  f(this, T, t), s(this, o).textTracks.add(t);
}, F = function() {
  s(this, T) && (s(this, o).textTracks.remove(s(this, T)), f(this, T, null));
}, pe = function(e, t) {
  s(this, o).qualities[J.enableAuto] = e.some((n) => n.id === "auto") ? () => h(this, i, u).call(this, "setQuality", "auto") : void 0;
  for (const n of e) {
    if (n.id === "auto") continue;
    const r = +n.id.slice(0, -1);
    isNaN(r) || s(this, o).qualities[M.add](
      {
        id: n.id,
        width: r * (16 / 9),
        height: r,
        codec: "avc1,h.264",
        bitrate: -1
      },
      t
    );
  }
  h(this, i, B).call(this, e.find((n) => n.active), t);
}, B = function({ id: e } = {}, t) {
  if (!e) return;
  const n = e === "auto", r = s(this, o).qualities.getById(e);
  n ? (s(this, o).qualities[J.setAuto](n, t), s(this, o).qualities[M.select](void 0, !0, t)) : s(this, o).qualities[M.select](r ?? void 0, !0, t);
}, ye = function(e, t, n) {
  switch (e) {
    case "ready":
      h(this, i, he).call(this);
      break;
    case "loaded":
      h(this, i, ne).call(this, n);
      break;
    case "play":
      h(this, i, ae).call(this, n);
      break;
    case "playProgress":
      h(this, i, ce).call(this, n);
      break;
    case "pause":
      h(this, i, re).call(this, n);
      break;
    case "loadProgress":
      h(this, i, q).call(this, t.seconds, n);
      break;
    case "waiting":
      h(this, i, fe).call(this, n);
      break;
    case "bufferstart":
      h(this, i, ue).call(this, n);
      break;
    case "bufferend":
      h(this, i, le).call(this, n);
      break;
    case "volumechange":
      h(this, i, L).call(this, t.volume, A(s(this, o).$state.muted), n);
      break;
    case "durationchange":
      f(this, k, new g(0, t.duration)), s(this, o).notify("duration-change", t.duration, n);
      break;
    case "playbackratechange":
      s(this, o).notify("rate-change", t.playbackRate, n);
      break;
    case "qualitychange":
      h(this, i, B).call(this, t, n);
      break;
    case "fullscreenchange":
      f(this, S, t.fullscreen), s(this, o).notify("fullscreen-change", t.fullscreen, n);
      break;
    case "enterpictureinpicture":
      s(this, o).notify("picture-in-picture-change", !0, n);
      break;
    case "leavepictureinpicture":
      s(this, o).notify("picture-in-picture-change", !1, n);
      break;
    case "ended":
    case "finish":
      s(this, o).notify("end", void 0, n);
      break;
    case "error":
      h(this, i, be).call(this, t, n);
      break;
    case "seek":
    case "seeked":
      h(this, i, ie).call(this, t.seconds, n);
      break;
  }
}, be = function(e, t) {
  var l;
  const { message: n, method: r } = e;
  r === "setPlaybackRate" && s(this, m).set(!1), r && ((l = h(this, i, z).call(this, r)) == null || l.reject(n));
}, u = async function(e, t) {
  let n = G(), r = s(this, v).get(e);
  return r || s(this, v).set(e, r = []), r.push(n), this.postMessage({
    method: e,
    value: t
  }), n.promise;
}, D = function() {
  s(this, R).stop(), f(this, k, new g(0, 0)), f(this, V, null), f(this, I, null), s(this, m).set(!1), h(this, i, F).call(this);
}, z = function(e) {
  var t;
  return (t = s(this, v).get(e)) == null ? void 0 : t.shift();
};
const je = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  VimeoProvider: Se
}, Symbol.toStringTag, { value: "Module" }));
export {
  je as p,
  Ie as u
};
